module.exports = __webpack_public_path__ + "static/img/lijun1.97c74e46.png";